export default {
  resource:{
    zh: {
      title:"考勤日报",
      xdate: "日期",
      companyNo:"公司",
      deptNo: "部门",
      empId:"工号",
      empName:"姓名",
      companyName:"公司",
      dept: "部门",
      job:"岗位",
      workDay:"工作天数",
      workTime:"工作时间",
      absenceTime:"缺勤时间",
      lateTime:"迟到时间",
      earlyTime:"早退时间",
      leaveTime:"请假时间",
      paidLeaveTime:"有薪假时间",
      holidayTime:"放假时间",
      restTime:"休息时间",
      overTime:"加班时间",
      injuryTime:"工伤时间",
      sj1:"时间1",
      sj2:"时间2",
      sj3:"时间3",
      sj4:"时间4",
      sj5:"时间5",
      sj6:"时间6",
      sj7:"时间7",
      sj8:"时间8"
    }
    

  },
  params: {
    companyNo:{
      key: "companyNo",
      defaultIdx: 0,
      method: "Equal",
      type: "select",
      options:"company"
    },
    xdate:{
      key: "xdate",
      method: "Equal",
      type: "date"
    },
    empId:{
      key: "empId",
      data: null,
      more: true,
      method: "Equal",
      type: "number"
    },
    empName:{
      key: "empName",
      data: null,
      more: true,
      method: "Contains",
      type: "text"
    },
    deptNo:{
      key: "deptNo",
      data: "",
      more: true,
      method: "Equal",
      type: "select",
      options:[{
        value: "",
        text: "All"
      }]
    }
  },
  listDefine: [
    "dept","job","empId", "empName",{key:"workDay",formatter:"numberFix1"},
    {
      key: "workTime",
      type: "sortClumn",
      formatter:"ftime"
    },
    {
      key: "overTime",
      type: "sortClumn",
      formatter:"ftime"
    },
    {
      key: "absenceTime",
      type: "sortClumn",
      formatter:"ftime"
    },
    {
      key: "lateTime",
      type: "sortClumn",
      formatter:"ftime"
    },
    {
      key: "earlyTime",
      type: "sortClumn",
      formatter:"ftime"
    },
    {
      key: "leaveTime",
      type: "sortClumn",
      formatter:"ftime"
    },
    {
      key: "paidLeaveTime",
      type: "sortClumn",
      formatter:"ftime"
    },
    {
      key: "holidayTime",
      type: "sortClumn",
      formatter:"ftime"
    },
    {
      key: "restTime",
      type: "sortClumn",
      formatter:"ftime"
    },
    {
      key: "injuryTime",
      type: "sortClumn",
      formatter:"ftime"
    },
    { key: "sj1", type: "sortClumn",formatter:"ftime"},
    { key: "sj2", type: "sortClumn",formatter:"ftime"},
    { key: "sj3", type: "sortClumn",formatter:"ftime"},
    { key: "sj4", type: "sortClumn",formatter:"ftime"},
    { key: "sj5", type: "sortClumn",formatter:"ftime"},
    { key: "sj6", type: "sortClumn",formatter:"ftime"},
    { key: "sj7", type: "sortClumn",formatter:"ftime"},
    { key: "sj8", type: "sortClumn",formatter:"ftime"}
  ],
  isShowMore: true,
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  sortName: "deptNo",
  sortOrder: "asc",
  defaultSortName: "deptNo",
  defaultSortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "daily/"
}
